import axios from 'axios'

const ListService = {

  async getRoles (params = {}) {
    return axios.get('shared/list/roles', { params })
  },

  async getSuppliers (params = {}) {
    return axios.get('shared/list/suppliers', { params })
  },

  async getWarehouses (params = {}) {
    return axios.get('shared/list/warehouses', { params })
  },

  async getLocations (params = {}) {
    return axios.get('shared/list/locations', { params })
  },

  async getVehicles (params = {}) {
    return axios.get('shared/list/vehicles', { params })
  },

  async getDrivers (params = {}) {
    return axios.get('shared/list/drivers', { params })
  },

  async getGroups (params = {}) {
    return axios.get('shared/list/groups', { params })
  },

  async getCategories (params = {}) {
    return axios.get('shared/list/categories', { params })
  },

  async getProducts (params = {}) {
    return axios.get('shared/list/products', { params })
  },

  async getStocks (params = {}) {
    return axios.get('shared/inquiry/product-stocks', { params })
  },

  async getSystemOptions (params = {}) {
    return axios.get('shared/list/system-options', { params })
  }
}

export default ListService
